import { render, staticRenderFns } from "./AddFreeProductButton.vue?vue&type=template&id=08b6ade8"
import script from "./AddFreeProductButton.vue?vue&type=script&lang=js"
export * from "./AddFreeProductButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports